import { GetBankAccountQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getBankAccount/getBankAccountQuery.type';
import { getBankAccountFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getBankAccount/getBankAccountQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getBankAccountQueryOptions = (
  params: GetBankAccountQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['Get_Bank_Account', params],
    queryFn: () => getBankAccountFunction(params),
  });
};
